<template>
    <card :header-content-class="['w-100']">
        <template #header-icon>
            <font-awesome-icon :icon="['fas', 'credit-card']" size="lg" />
        </template>
        <template #header-content>
            <div class="lx-payment__title">
                Secure Payment Information
                <font-awesome-icon class="lx-payment__title__icon text-success" :icon="['fas', 'lock']" size="lg" />
            </div>
        </template>
        <template #body>
            <div v-if="loading">Loading...</div>
            <div v-else-if="settings">
                <div id="lx-online-booking-checkout-payment" class="lx-online-booking-checkout-payment">
                    <b-row>
                        <b-col md="8" lg="6">
                            <form-select
                                v-if="paymentOptions.length > 1"
                                v-model="client.payment_method_id"
                                floating-label="PAYMENT METHOD"
                                :options="paymentOptions"
                                @input="resetGuestCreditCode"
                            />
                            <div
                                v-if="client.payment_method_id === PAYMENT_METHOD_CHECK"
                                class="lx-online-booking-checkout-payment__check"
                            >
                                <validation-provider
                                    name="check_no"
                                    rules="required"
                                    v-slot="{ errors, handleChange }"
                                    
                                    validate-on-mount
                                >
                                    <form-input
                                        v-model="client.check_no"
                                        floating-label="CHECK NUMBER"
                                        :error="errors[0]"
                                        @input="handleChange"
                                    />
                                </validation-provider>
                                <div class="lx-online-booking-checkout-payment__check__policy">
                                    {{ settings.check_policy }}
                                </div>
                            </div>
                            <div v-if="client.payment_method_id === PAYMENT_METHOD_GIFT_CERTIFICATE">
                                <validation-provider
                                    name="gift_certificate_no"
                                    rules="required"
                                    v-slot="{ errors, handleChange }"
                                    
                                    validate-on-mount
                                >
                                    <form-input
                                        v-model="client.gift_certificate_no"
                                        floating-label="GIFT CERTIFICATE NUMBER"
                                        :error="errors[0]"
                                        @input="handleChange"
                                    />
                                </validation-provider>
                            </div>
                            <div
                                v-if="client.payment_method_id === PAYMENT_METHOD_PAYPAL"
                                class="lx-online-booking-checkout-payment__paypal"
                            >
                                <div class="lx-online-booking-checkout-payment__paypal__policy">
                                    {{ settings.paypal_details }}
                                </div>
                            </div>
                            <div v-if="client.payment_method_id === PAYMENT_METHOD_CREDIT_CARD">
                                <div v-if="reservation && reservation.is_proxy">
                                    <validation-provider
                                        name="channex_card_capture"
                                        rules="required|validChannexCard"
                                        v-slot="{ handleChange }"
                                        
                                    >
                                        <form-channex-card-capture
                                            v-model="client.channex_card_capture"
                                            ref="capture"
                                            :valid-payment-card-types="settings.card_types"
                                            @success-tokenize-card="handleSuccessTokenizeCard"
                                            :auto-validate="true"
                                            @input="handleChange"
                                        />
                                    </validation-provider>
                                </div>
                                <div v-else-if="(reservation && reservation.use_setup_intent) || usePaymentsIntent">
                                    <validation-provider
                                        name="stripe_setup_intent"
                                        rules="required|validStripeSetupIntent"
                                        v-slot="{ errors, handleChange }"
                                        validate-on-mount
                                    >
                                        <form-stripe-card
                                            v-model="client.stripe_setup_intent"
                                            :client-secret="stripeClientSecret"
                                            :publishable-key="stripePublishableKey"
                                            :stripe-account="stripeAccount"
                                            :valid-payment-card-types="settings.card_types"
                                            :error="errors[0]"
                                            @input="handleChange"
                                        />
                                    </validation-provider>
                                    <validation-provider
                                        name="card_name"
                                        rules="required"
                                        v-slot="{ errors, handleChange }"
                                        validate-on-mount
                                    >
                                        <form-input
                                            name="cc-name"
                                            autocomplete="cc-name"
                                            v-model="client.card_name"
                                            floating-label="CARD HOLDER NAME"
                                            :error="errors[0]"
                                            @input="handleChange"
                                        />
                                    </validation-provider>
                                </div>
                                <b-row class="mt-3" v-else-if="isProxy && isPaymentRequest">
                                    <b-col md="12">
                                        <channex-card-capture
                                            ref="capture"
                                            :valid-payment-card-types="settings.card_types"
                                            @success-tokenize-card="handleSuccessTokenizeCard"
                                        />
                                    </b-col>
                                </b-row>
                                <div class="lx-online-booking-checkout-payment__card" v-else>
                                    <validation-provider
                                        ref="cardNumber"
                                        name="card_number"
                                        :rules="{
                                            required: true,
                                            validPaymentCardNumber: {
                                                validPaymentCardTypes: settings.card_types,
                                            },
                                        }"
                                        v-slot="{ errors, handleChange }"
                                        
                                        validate-on-mount
                                    >
                                        <form-input
                                            name="cc-number"
                                            autocomplete="cc-number"
                                            :id="cardNumberInput"
                                            data-card-field
                                            v-model="cardNumber"
                                            v-mask="cardNumberMask"
                                            floating-label="CARD NUMBER"
                                            :error="errors[0]"
                                            @input="handleChange"
                                        />
                                    </validation-provider>
                                    <div class="lx-online-booking-checkout-payment__card__numbers">
                                        <b-row>
                                            <b-col md="6">
                                                <validation-provider
                                                    class="lx-online-booking-checkout-payment__card__numbers__expiry"
                                                    name="card_expiry"
                                                    rules="required|validPaymentCardExpiry"
                                                    v-slot="{ errors, handleChange }"
                                                    
                                                    validate-on-mount
                                                >
                                                    <form-input
                                                        name="cc-exp"
                                                        autocomplete="cc-exp"
                                                        :id="cardMonthInput"
                                                        data-card-field
                                                        v-model="client.card_expiry"
                                                        v-mask="cardExpiryMask"
                                                        floating-label="MM/YY"
                                                        :error="errors[0]"
                                                        @input="handleChange"
                                                    />
                                                </validation-provider>
                                            </b-col>
                                            <b-col md="6">
                                                <validation-provider
                                                    class="lx-online-booking-checkout-payment__card__numbers__cvv"
                                                    name="card_code"
                                                    :rules="`required|validPaymentCardCvv:${cardCvvLength}`"
                                                    v-slot="{ errors, handleChange }"
                                                    
                                                    validate-on-mount
                                                >
                                                    <form-input
                                                        name="cc-csc"
                                                        autocomplete="cc-csc"
                                                        :id="cardCvvInput"
                                                        data-card-field
                                                        v-model="client.card_code"
                                                        v-mask="cardCvvMask"
                                                        :floating-label="cardCvvLabel"
                                                        :error="errors[0]"
                                                        @input="handleChange"
                                                    />
                                                </validation-provider>
                                            </b-col>
                                        </b-row>
                                    </div>
                                    <validation-provider
                                        name="card_name"
                                        rules="required|validPaymentCardholderName|maxMessageLen:65,Card holder name"
                                        v-slot="{ errors, handleChange }"
                                        
                                        validate-on-mount
                                    >
                                        <form-input
                                            name="cc-name"
                                            autocomplete="cc-name"
                                            :id="cardNameInput"
                                            data-card-field
                                            v-model="client.card_name"
                                            floating-label="CARDHOLDER NAME"
                                            :error="errors[0]"
                                            @input="handleChange"
                                        />
                                    </validation-provider>
                                </div>
                            </div>
                            <div
                                v-if="client.payment_method_id === PAYMENT_METHOD_BANK_TRANSFER"
                                class="lx-online-booking-checkout-payment__bank-transfer"
                            >
                                <div class="lx-online-booking-checkout-payment__bank-transfer__policy">
                                    {{ settings.bank_transfer_details }}
                                </div>
                            </div>
                            <div
                                v-if="client.payment_method_id === NO_PAYMENT_METHOD"
                                class="lx-online-booking-checkout-payment__no-payment"
                            >
                                <div class="lx-online-booking-checkout-payment__no-payment__policy">
                                    {{ settings.no_payment_policy }}
                                </div>
                            </div>
                            <div
                                v-if="client.payment_method_id === PAYMENT_METHOD_E_CHECK"
                                class="lx-online-booking-checkout-payment__echeck"
                            >
                                <span v-if="(reservation && reservation.use_setup_intent) || usePaymentsIntent">
                                    <b-row>
                                        <b-col md="12">
                                            <validation-provider
                                                name="echeck_account_name"
                                                rules="required|maxMessageLen:23, Account name"
                                                v-slot="{ errors, handleChange }"
                                                
                                                validate-on-mount
                                            >
                                                <form-input
                                                    v-model="client.echeck_account_name"
                                                    :leftIcon="['fas', 'user']"
                                                    autocomplete="cc-name"
                                                    floating-label="FULL NAME"
                                                    :error="errors[0]"
                                                    @input="handleChange"
                                                />
                                            </validation-provider>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col md="12">
                                            <validation-provider
                                                name="echeck_holder_email"
                                                v-slot="{ errors, handleChange }"
                                                rules="email|required"
                                                
                                                validate-on-mount
                                            >
                                                <form-input
                                                    v-model="client.echeck_holder_email"
                                                    :leftIcon="['fas', 'at']"
                                                    autocomplete="email"
                                                    floatingLabel="EMAIL"
                                                    :error="errors[0]"
                                                    @input="handleChange"
                                                ></form-input>
                                            </validation-provider>
                                        </b-col>
                                    </b-row>
                                </span>
                                <span v-else>
                                    <validation-provider
                                        name="echeck_routing_no"
                                        rules="required|validRoutingNumber"
                                        v-slot="{ errors, handleChange }"
                                        
                                        validate-on-mount
                                    >
                                        <form-input
                                            v-model="client.echeck_routing_no"
                                            floating-label="ROUTING NUMBER"
                                            :error="errors[0]"
                                            @input="handleChange"
                                        />
                                    </validation-provider>
                                    <validation-provider
                                        name="echeck_account_no"
                                        rules="required|validAccountNumber"
                                        v-slot="{ errors, handleChange }"
                                        
                                        validate-on-mount
                                    >
                                        <form-input
                                            v-model="client.echeck_account_no"
                                            floating-label="ACCOUNT NUMBER"
                                            :error="errors[0]"
                                            @input="handleChange"
                                        />
                                    </validation-provider>
                                    <validation-provider
                                        name="echeck_account_name"
                                        rules="required|maxMessageLen:23, Account name"
                                        v-slot="{ errors, handleChange }"
                                        
                                        validate-on-mount
                                    >
                                        <form-input
                                            v-model="client.echeck_account_name"
                                            floating-label="ACCOUNT NAME"
                                            :error="errors[0]"
                                            @input="handleChange"
                                        />
                                    </validation-provider>
                                    <validation-provider
                                        name="echeck_bank_name"
                                        rules="required|maxMessageLen:51, Bank name"
                                        v-slot="{ errors, handleChange }"
                                        
                                        validate-on-mount
                                    >
                                        <form-input
                                            v-model="client.echeck_bank_name"
                                            floating-label="BANK NAME"
                                            :error="errors[0]"
                                            @input="handleChange"
                                        />
                                    </validation-provider>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <form-select
                                                v-model="client.echeck_account_type"
                                                floating-label="ACCOUNT TYPE"
                                                :options="accountTypeOptions"
                                            />
                                        </div>
                                        <div class="col-md-6">
                                            <form-select
                                                v-model="client.echeck_check_type"
                                                floating-label="CHECK TYPE"
                                                :options="checkTypeOptions"
                                            />
                                        </div>
                                    </div>
                                </span>
                                <div v-if="settings.echeck_details">
                                    <div class="lx-online-booking-checkout-payment__echeck__policy">
                                        {{ settings.echeck_details }}
                                    </div>
                                </div>
                            </div>
                            <div v-if="client.payment_method_id === PAYMENT_METHOD_GUEST_CREDIT">
                                <validation-provider
                                    name="guest_credit_code"
                                    :rules="{
                                        validGuestCreditCode: {
                                            url: website.url,
                                            onLoading: handleGuestCreditCodeLoading,
                                            onSuccess: handleGuestCreditCodeSuccess,
                                            onExpired: handleGuestCreditCodeExpired,
                                            onRedeemed: handleGuestCreditCodeRedeemed,
                                            onFailure: handleGuestCreditCodeFailure,
                                        },
                                    }"
                                    v-slot="{ errors, handleChange }"
                                    validate-on-mount
                                >
                                    <form-input
                                        v-model="client.guest_credit_code"
                                        floating-label="GUEST CREDIT CODE"
                                        :description="validatingGuestCreditCode ? '...' : null"
                                        :error="errors[0]"
                                        @change="handleChange"
                                    />
                                </validation-provider>
                                <div v-if="client.guest_credit_amount > 0">
                                    A credit in the amount of
                                    <b>{{ getGuestCreditTotalAmount() }}</b>
                                    has been applied to this invoice.
                                </div>
                            </div>
                            <div class="lx-online-booking-checkout-payment__pay-button">
                                <b-button
                                    v-if="paymentAmount"
                                    size="lg"
                                    variant="success"
                                    @click="submitPayment"
                                    :disabled="invalid"
                                >
                                    PAY {{ paymentAmount }}
                                </b-button>
                            </div>
                        </b-col>
                        <b-col>
                            <b-row class="no-gutters">
                                <billing-card-icons
                                    :acceptedCards="settings.card_types"
                                    :showIcons="
                                        client.payment_method_id === PAYMENT_METHOD_CREDIT_CARD
                                            ? 'credit-card'
                                            : client.payment_method_id === PAYMENT_METHOD_E_CHECK &&
                                              ((reservation && reservation.use_setup_intent) || usePaymentsIntent)
                                            ? 'ach-direct-debit'
                                            : client.payment_method_id === PAYMENT_METHOD_E_CHECK
                                            ? 'echeck'
                                            : ''
                                    "
                                />
                            </b-row>

                            <b-row
                                v-if="client.payment_method_id === PAYMENT_METHOD_CREDIT_CARD"
                                class="lx-online-booking-checkout-payment__bank-transfer no-gutters"
                            >
                                <div class="lx-online-booking-checkout-payment__bank-transfer__policy">
                                    {{ settings.credit_card_details }}
                                </div>
                            </b-row>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <div v-else></div>
        </template>
    </card>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import differenceInDays from 'date-fns/differenceInDays';
import { mapGetters } from 'vuex';
import * as paymentCardValidator from 'card-validator';
import { defineRule as extend } from 'vee-validate';
import API from '../../../../api';
import { ONLINE_BOOKING_GUEST_CREDIT_BY_ID_ENDPOINT } from '../../../../endpoints';
import { getCardNumberMaskFromBraintreeCardObject } from '../../../../utils/payments';
import { toAmountDisplay } from '../../../../utils/numbers';
import Card from '../../../generic/card/card.vue';
import FormInput from '../../../generic/form-input/form-input.vue';
import FormSelect from '../../../generic/form-select/form-select.vue';
import FormStripeCard from '../../../generic/form-stripe-card/form-stripe-card.vue';
import BillingCardIcons from '../../../generic/billing-card-icons/billing-card-icons.vue';
import FormChannexCardCapture from '../../../generic/form-channex-card-capture/form-channex-card-capture.vue';
import ChannexCardCapture from '../../../generic/channex-card-capture/channex-card-capture.vue';
import {
    PAYMENT_CARD_AMERICAN_EXPRESS,
    PAYMENT_CARD_DINERS_CLUB,
    PAYMENT_CARD_DISCOVER,
    PAYMENT_CARD_MASTERCARD,
    PAYMENT_CARD_VISA,
    PAYMENT_METHOD_CHECK,
    PAYMENT_METHOD_GIFT_CERTIFICATE,
    PAYMENT_METHOD_PAYPAL,
    PAYMENT_METHOD_CREDIT_CARD,
    PAYMENT_METHOD_BANK_TRANSFER,
    NO_PAYMENT_METHOD,
    PAYMENT_METHOD_E_CHECK,
    PAYMENT_METHOD_GUEST_CREDIT,
    convertFromBraintreeCardType,
} from '../../../../constants';

extend(
    'validGuestCreditCode',
    // computesRequired: true,
    // params: ['url', 'onLoading', 'onSuccess', 'onExpired', 'onRedeemed', 'onFailure'],
    async (value, { url, onLoading, onSuccess, onExpired, onRedeemed, onFailure }) => {
        if (value && value.length === 12) {
            onLoading();
            try {
                const response = await API.get(ONLINE_BOOKING_GUEST_CREDIT_BY_ID_ENDPOINT(url, value));

                const status = response.data.status;
                const credit = response.data.credit;

                if (status === 'REDEEMED') {
                    onRedeemed();
                    return 'Guest credit code already redeemed.';
                } else if (status === 'EXPIRED') {
                    onExpired();
                    return 'Guest credit code already expired.';
                } else if (isEmpty(credit)) {
                    onFailure();
                    return 'Wrong guest credit code.';
                }

                onSuccess({ amount: credit.amount });
                return true;
            } catch {
                onFailure();
                return 'Something went wrong while validating guest credit code.';
            }
        } else {
            onFailure();
            return 'Guest credit code is invalid.';
        }
    },
    {
        params: ['url', 'onLoading', 'onSuccess', 'onExpired', 'onRedeemed', 'onFailure'],
        computesRequired: true,
    }
);

extend('validStripeSetupIntent', (value) => {
    if (value === 'OK') {
        return true;
    }
    return value;
});

extend('validChannexCard', (value) => {
    if (value === 'OK') {
        return true;
    }
    return value;
});

export default {
    name: 'OnlineBookingCheckoutPayment',
    components: {
        Card,
        FormInput,
        FormSelect,
        FormStripeCard,
        BillingCardIcons,
        FormChannexCardCapture,
        ChannexCardCapture,
    },
    props: {
        isChannexAllowed: {
            type: Boolean,
            default: false,
        },
        isPaymentRequest: {
            type: Boolean,
            default: false,
        },
        usePaymentsIntent: {
            type: Boolean,
            default: false,
        },
        paymentAmount: {
            type: String,
            default: null,
        },
        fromDate: {
            type: String,
            default: null,
        },
        invalid: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        (async () => {
            this.loading = true;
            try {
                await this.fetchSettings();
                if (this.client.payment_method_id === PAYMENT_METHOD_E_CHECK && this.stripePublishableKey) {
                    await this.$store.dispatch('stripe/loadStripe', {
                        publishableKey: this.stripePublishableKey,
                        stripeAccount: this.stripeAccount,
                    });
                }
            } finally {
                this.loading = false;
            }
        })();
    },
    computed: {
        ...mapGetters('stripe', ['stripe']),
        ...mapGetters('onlineBooking', ['client', 'reservation', 'settings', 'stripeClientSecret', 'website']),
        isProxy() {
            return window.IS_PROXY;
        },
        cardNumber: {
            get() {
                return this.client.card_number;
            },
            set(cardNumber) {
                this.client.card_number = cardNumber;

                const { card } = paymentCardValidator.number(cardNumber);
                if (card) {
                    this.client.card_type = convertFromBraintreeCardType(card.type);
                    this.cardNumberMask = getCardNumberMaskFromBraintreeCardObject(card);
                    this.cardCvvLabel = card.code.name;
                    this.cardCvvLength = card.code.size;
                    this.cardCvvMask = '#'.repeat(card.code.size);
                }
            },
        },
        paymentOptions() {
            let paymentOptions = null;

            if (!this.settings) {
                return [];
            }
            if (this.isPaymentRequest) {
                this.settings.payment_methods = this.settings.payment_methods.filter((m) => [4, 9].includes(m.id));
            }
            if (differenceInDays(new Date(this.reservation?.from_date || this.fromDate), new Date()) < 9) {
                paymentOptions = this.settings.payment_methods
                    .filter((m) => m.id !== 9)
                    .map((method) => ({
                        value: method.id,
                        text: method.name,
                    }));
                // this.client.payment_method_id = paymentOptions[0].value;  incorrectly works, see setEcheckPaymentOption

                return paymentOptions;
            }
            paymentOptions = this.settings.payment_methods.map((method) => ({
                value: method.id,
                text: method.name,
            }));
            return paymentOptions;
        },
        accountTypeOptions() {
            return ['Checking', 'Savings'];
        },
        checkTypeOptions() {
            return ['Personal', 'Business'];
        },
        isAmericanExpressSupported() {
            if (!this.settings) {
                return false;
            }
            return this.settings.card_types.find((type) => type.id === PAYMENT_CARD_AMERICAN_EXPRESS);
        },
        isDinersClubSupported() {
            if (!this.settings) {
                return false;
            }
            return this.settings.card_types.find((type) => type.id === PAYMENT_CARD_DINERS_CLUB);
        },
        isDiscoverSupported() {
            if (!this.settings) {
                return false;
            }
            return this.settings.card_types.find((type) => type.id === PAYMENT_CARD_DISCOVER);
        },
        isMastercardSupported() {
            if (!this.settings) {
                return false;
            }
            return this.settings.card_types.find((type) => type.id === PAYMENT_CARD_MASTERCARD);
        },
        isVisaSupported() {
            if (!this.settings) {
                return false;
            }
            return this.settings.card_types.find((type) => type.id === PAYMENT_CARD_VISA);
        },
    },
    data() {
        return {
            loading: false,
            PAYMENT_METHOD_CHECK,
            PAYMENT_METHOD_GIFT_CERTIFICATE,
            PAYMENT_METHOD_PAYPAL,
            PAYMENT_METHOD_CREDIT_CARD,
            PAYMENT_METHOD_BANK_TRANSFER,
            NO_PAYMENT_METHOD,
            PAYMENT_METHOD_E_CHECK,
            PAYMENT_METHOD_GUEST_CREDIT,
            cardType: '',
            cardNumberInput: 'lx-card-number',
            cardNumberMask: '#### #### #### ####',
            cardNameInput: 'lx-card-name',
            cardMonthInput: 'lx-card-month',
            cardCvvInput: 'lx-card-cvv',
            cardCvvLabel: 'CVV',
            cardCvvMask: '####',
            cardCvvLength: 4,
            cardExpiryMask: '##/##',
            validatingGuestCreditCode: false,
            stripeAccount: window.STRIPE_ACCOUNT,
            stripePublishableKey: window.STRIPE_PUBLISHABLE_KEY,
        };
    },
    methods: {
        async fetchSettings() {
            try {
                await this.$store.dispatch('onlineBooking/fetchSettings');
                this.setEcheckPaymentOption();
            } catch {
                this.errorToast({
                    text: 'Could not load settings.',
                });
            }
        },
        async submitPayment() {
            if (this.isProxy && this.client.payment_method_id === PAYMENT_METHOD_CREDIT_CARD) {
                const response = await this.$refs.capture.submit();
            } else {
                this.$emit('submitPayment');
            }
        },
        handleGuestCreditCodeLoading() {
            this.validatingGuestCreditCode = true;
        },
        handleGuestCreditCodeSuccess({ amount }) {
            this.$store.commit('onlineBooking/gotClientGuestCreditAmount', amount);
            this.validatingGuestCreditCode = false;
        },
        handleGuestCreditCodeRedeemed() {
            this.$store.commit('onlineBooking/gotClientGuestCreditAmount', 0);
            this.client.guest_credit_status = 'REDEEMED';
            this.validatingGuestCreditCode = false;
        },
        handleGuestCreditCodeExpired() {
            this.$store.commit('onlineBooking/gotClientGuestCreditAmount', 0);
            this.client.guest_credit_status = 'EXPIRED';
            this.validatingGuestCreditCode = false;
        },
        handleGuestCreditCodeFailure() {
            this.$store.commit('onlineBooking/gotClientGuestCreditAmount', 0);
            this.client.guest_credit_status = 'FAIL';
            this.validatingGuestCreditCode = false;
        },
        resetGuestCreditCode(value) {
            if (this.client.guest_credit_code) {
                this.client.guest_credit_code = '';
                this.$store.commit('onlineBooking/gotClientGuestCreditAmount', 0);
                this.client.guest_credit_status = 'FAIL';
                this.validatingGuestCreditCode = false;
            }
        },
        getGuestCreditTotalAmount() {
            return toAmountDisplay({
                amount: this.client.guest_credit_amount,
                currency: this.reservation.currency.symbol,
            });
        },
        handleSuccessTokenizeCard(card) {
            this.client.card_type = convertFromBraintreeCardType(card.card_type);
            this.client.card_number = card.card_number;
            this.client.card_name = card.cardholder_name;
            this.client.card_expiry = `${card.expiration_month}/${card.expiration_year}`;
            this.client.pci_token = card.card_token;
            this.$emit('submitPayment');
            if (this.isPaymentRequest) {
                this.$refs.capture.fetchSessionToken();
            } else {
                this.$refs.capture.$refs.capture.fetchSessionToken();
            }
        },
        setEcheckPaymentOption() {
            const hasEcheck = this.settings.payment_methods.find((option) => option.id === PAYMENT_METHOD_E_CHECK);
            if (differenceInDays(new Date(this.reservation?.from_date || this.fromDate), new Date()) < 9 && hasEcheck) {
                this.client.payment_method_id = this.paymentOptions.filter(
                    (item) => item.value !== PAYMENT_METHOD_E_CHECK
                )[0].value;
            }
        },
    },
    watch: {
        'client.payment_method_id': function (paymentMethodId, previousPaymentMethodId) {
            if (
                paymentMethodId == PAYMENT_METHOD_E_CHECK && this.stripePublishableKey &&
                ((this.reservation && this.reservation.use_setup_intent) || this.usePaymentsIntent)
            ) {
                (async () => {
                    await this.$store.dispatch('stripe/loadStripe', {
                        publishableKey: this.stripePublishableKey,
                        stripeAccount: this.stripeAccount,
                    });
                })();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/_functions.scss';
@import '~bootstrap/scss/_variables.scss';
@import '~bootstrap/scss/mixins/_breakpoints.scss';

.lx-payment__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &__icon {
        margin-right: 1.5rem;
    }
}

#lx-online-booking-checkout-payment .lx-online-booking-checkout-payment {
    &__check {
        &__policy {
            white-space: pre-line;
        }
    }

    &__echeck {
        &__policy {
            white-space: pre-line;
        }
    }

    &__paypal {
        &__policy {
            white-space: pre-line;
        }
    }

    &__no-payment {
        &__policy {
            white-space: pre-line;
        }
    }

    &__bank-transfer {
        &__policy {
            white-space: pre-line;
        }
    }

    &__pay-button {
        @media (max-width: 991px) {
            text-align: center;
            margin: 0.5rem 0rem 0.5rem 0;
            button {
                margin-right: 0.2rem;
            }
        }
        @media (min-width: 992px) {
            button {
                margin: 0.5rem 0 1rem 0;
            }
        }
    }
}
</style>
